import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
  useTheme,
} from "@mui/material";
import { ControllerRenderProps } from "react-hook-form";
import { FieldPath, FieldValues } from "react-hook-form/dist/types";
import { CarrierIdentifier } from "./CarrierIdentifier";
import { useFetchCarriers } from "./Hooks/useFetchCarriers";
import { selectDefaultProps } from "../Forms/selectDefaultProps";
import { emptyMenuItem } from "../Forms/SelectDefaultComponents";

interface GsdbSelectProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> {
  field: ControllerRenderProps<TFieldValues, TName>;
  errorMessage: string | undefined;
  onCarrierChanged?: (carrierId: number, gsdbs: CarrierIdentifier[]) => void;
}

export function CarrierSelect<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  field,
  errorMessage,
  onCarrierChanged,
  disabled,
  ...otherProps
}: GsdbSelectProps<TFieldValues, TName> & SelectProps) {
  const { data: carriers } = useFetchCarriers();
  const theme = useTheme();

  const label = "Carrier";

  return (
    <FormControl fullWidth size="small" disabled={disabled}>
      <InputLabel id="carrier-label" shrink required>
        {label}
      </InputLabel>
      <Select
        {...selectDefaultProps}
        {...otherProps}
        {...field}
        labelId="carrier-label"
        label={label}
        onChange={(event) => {
          if (onCarrierChanged) onCarrierChanged(event.target.value as number, carriers || []);
          field.onChange(event);
        }}
        disabled={disabled}
      >
        {emptyMenuItem(0)}
        {carriers &&
          carriers.map((carrier) => (
            <MenuItem key={carrier.Id} value={carrier.Id}>
              {carrier.Gsdb} - {carrier.Name}
            </MenuItem>
          ))}
      </Select>
      <FormHelperText
        sx={{
          color: theme.palette.error.main,
          position: "absolute",
          bottom: "-1.5rem",
        }}
      >
        {errorMessage}
      </FormHelperText>
    </FormControl>
  );
}
